/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

//table columns for user management table listing 
export const columns: TableColumn[] = [
    {
        Header: 'tableCommon.sl_no',
        accessor: 'slno',
      },
      {
        Header: 'configuration.tableColumns.material_name',
        accessor: 'material_type',
      },
      {
        Header: 'configuration.tableColumns.material_code',
        accessor: 'material_type_code',
      },
]

interface TableColumn {
    Header: string;
    accessor: string;
  }


export const columnsSubType: TableColumn[] = [
    {
        Header: 'tableCommon.sl_no',
        accessor: 'slno',
      },
      {
        Header: 'configuration.tableColumns.name',
        accessor: 'material_sub_type_name',
      },
      {
        Header: 'tableCommon.material_type',
        accessor: 'material_type',
      },
      {
        Header: 'configuration.tableColumns.material_type_code',
        accessor: 'material_type_code',
      },
]